<script>
export default {
    name: 'IconCross',
}
</script>
<template>
    <svg class="base-icon icon-cross" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M57.38 0 64 6.62 38.62 31.999 64 57.38 57.38 64 32 38.62 6.62 64 0 57.38 25.38 32 0 6.62 6.62 0 32 25.38 57.38 0Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>
